import defaultConfig from "../configs/default.json";

export const getControlEffectivenessValues = (config) =>
  Object.entries((config && config.Control) || defaultConfig.config.Control);

export const getControlEffectivenessName = (score, config) => {
  const controlEffectiveness = getControlEffectivenessValues(config).find((value) => Number(value[0]) === Number(score));
  return controlEffectiveness ? controlEffectiveness[1] : "";
};
